import { http } from '@/utils/http';
import { unwrap } from '@/utils/apiClient';
import type { VoiceResponse } from './voice';

/**
 * 收藏文本接口
 */
export interface FavoriteText {
  id: number;
  title: string;
  text: string;
  isSSML: boolean;
  engineParams?: Record<string, any>;
  tags?: string[];
  isPinned: boolean;
  length: number;
  updatedAt: Date;
  createdAt: Date;
}

/**
 * 添加收藏文本请求
 */
export interface AddFavoriteTextRequest {
  title: string;
  text: string;
  isSSML?: boolean;
  useEngineParams?: boolean;
  engineParams?: Record<string, any>;
  tags?: string[];
}

/**
 * 更新收藏文本请求
 */
export interface UpdateFavoriteTextRequest {
  title?: string;
  text?: string;
  isPinned?: boolean;
  engineParams?: Record<string, any>;
  tags?: string[];
}

/**
 * 获取收藏文本列表响应
 */
export interface GetFavoriteTextsResponse {
  list: FavoriteText[];
  total: number;
}

/**
 * 删除收藏文本响应
 */
export interface DeleteFavoriteTextResponse {
  success: boolean;
  message: string;
}

/**
 * 收藏操作响应
 */
export interface FavoriteActionResponse {
  success: boolean;
  isFavorite: boolean;
  message: string;
}

/**
 * 收藏API - 统一管理主播和文本收藏
 */
export const favoritesApi = {
  // ============= 主播收藏 =============

  /**
   * 获取收藏主播列表
   */
  getVoices: () => {
    return unwrap<VoiceResponse[]>(() =>
      http.get('/api/v1/favorites/voices')
    );
  },

  /**
   * 添加收藏主播
   */
  addVoice: (voiceId: number) => {
    return unwrap<FavoriteActionResponse>(() =>
      http.post(`/api/v1/favorites/voices/${voiceId}`)
    );
  },

  /**
   * 删除收藏主播
   */
  deleteVoice: (voiceId: number) => {
    return unwrap<FavoriteActionResponse>(() =>
      http.delete(`/api/v1/favorites/voices/${voiceId}`)
    );
  },

  // ============= 文本收藏 =============

  /**
   * 获取收藏文本列表
   */
  getTexts: () => {
    return unwrap<GetFavoriteTextsResponse>(() =>
      http.get('/api/v1/favorites/texts')
    );
  },

  /**
   * 添加收藏文本
   */
  addText: (request: AddFavoriteTextRequest) => {
    return unwrap<FavoriteText>(() =>
      http.post('/api/v1/favorites/texts', request)
    );
  },

  /**
   * 更新收藏文本
   */
  updateText: (id: number, request: UpdateFavoriteTextRequest) => {
    return unwrap<FavoriteText>(() =>
      http.patch(`/api/v1/favorites/texts/${id}`, request)
    );
  },

  /**
   * 删除收藏文本
   */
  deleteText: (id: number) => {
    return unwrap<DeleteFavoriteTextResponse>(() =>
      http.delete(`/api/v1/favorites/texts/${id}`)
    );
  },

  /**
   * 复制收藏文本
   */
  duplicateText: (id: number) => {
    return unwrap<FavoriteText>(() =>
      http.post(`/api/v1/favorites/texts/${id}/duplicate`)
    );
  }
};

